const WATERMARK_LINES = [
	"This Genogram was ",
	"Built With Qwoach.",
	"",
	"To Remove This Watermark,",
	"Please Save This Genogram First."
]
const WATERMARK_FONT_SIZE_PX = 50
const WATERMARK_LINE_HEIGHT_PX = WATERMARK_FONT_SIZE_PX
const WATERMARK_COLOR = "rgba(60, 60, 60, 0.4)"
const WATERMARK_QUADRANT_WIDTH = 900
const WATERMARK_QUADRANT_HEIGHT = 400

export default class GenogramExportWatermarkHelper {
	applyToCanvas(ctx, canvas) {
		let watermarkTextHeight = WATERMARK_LINE_HEIGHT_PX * WATERMARK_LINES.length
		let left = 0
		let top = 0

		ctx.fillStyle = WATERMARK_COLOR
		ctx.font = this.buildCanvasFont(ctx.font)

		while (left < canvas.width){
			while (top < canvas.height){
				this.drawCanvasWatermarkBlock(ctx, left, top, watermarkTextHeight)
				top += WATERMARK_QUADRANT_HEIGHT
			}
			top = 0
			left += WATERMARK_QUADRANT_WIDTH
		}
	}

	drawCanvasWatermarkBlock(ctx, left, top, watermarkTextHeight) {
		let lineIndex = 0
		for(let line of WATERMARK_LINES){
			let {width} = ctx.measureText(line)
			let x = left + (WATERMARK_QUADRANT_WIDTH - width) / 2
			let y = top + (WATERMARK_QUADRANT_HEIGHT - watermarkTextHeight) / 2 + lineIndex * WATERMARK_LINE_HEIGHT_PX
			ctx.fillText(line, x, y)
			lineIndex++
		}
	}

	buildCanvasFont(baseFont = "") {
		if(/\d+px/.test(baseFont)){
			return baseFont.replace(/\d+px/, WATERMARK_FONT_SIZE_PX + "px")
		}
		return `${WATERMARK_FONT_SIZE_PX}px Arial`
	}
}
